import styled from 'styled-components';

import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const TableWrap = styled.div({
  border: `${pxToRem(1)} solid ${theme.color.border10}`,
  borderRadius: pxToRem(8),
  overflow: 'hidden',
});
